import classNames from "classnames";
import { FC, ReactElement } from "react";

import styles from "./style.module.scss";

type Props = {
  children: ReactElement;
  title?: string;
  description?: ReactElement | string;
};

const LoginTemplate: FC<Props> = ({ children, title, description }) => {
  return (
    <div className={classNames(styles["login-template"])}>
      <div className={styles["login-template__content"]}>
        <div className={styles["login-template__content-header"]}>
          {title && <h1>{title}</h1>}
          {description && <p>{description}</p>}
        </div>

        {children}
      </div>
    </div>
  );
};

export default LoginTemplate;
